var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.631,
    cy: 46.631,
    r: 46.631,
    fill: "#A22341",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1309 46.3535C72.1309 60.1606 60.938 71.3535 47.1309 71.3535C33.3237 71.3535 22.1309 60.1606 22.1309 46.3535C22.1309 32.5464 33.3237 21.3535 47.1309 21.3535C60.938 21.3535 72.1309 32.5464 72.1309 46.3535ZM55.5278 54.7503C54.7955 55.4825 53.6084 55.4825 52.8761 54.7503L47.1309 49.005L41.3856 54.7503C40.6534 55.4825 39.4662 55.4825 38.734 54.7503C38.0017 54.0181 38.0017 52.8309 38.734 52.0986L44.4792 46.3534L38.734 40.6081C38.0018 39.8759 38.0018 38.6887 38.734 37.9565C39.4662 37.2242 40.6534 37.2242 41.3856 37.9565L47.1309 43.7017L52.8761 37.9565C53.6083 37.2243 54.7955 37.2243 55.5277 37.9565C56.26 38.6887 56.26 39.8759 55.5277 40.6082L49.7825 46.3534L55.5278 52.0986C56.26 52.8308 56.26 54.018 55.5278 54.7503Z",
    fill: "#F97068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.3b1416e59bb6d185af4e60a7dc51fb6f.svg";
export { ForwardRef as ReactComponent };